import { DRIVER_ROUTES } from '@/modules/drivers/routes-typed'
import { VEHICLE_ROUTES } from '@/modules/vehicles/routes-typed'
import { HOME_ROUTES } from '@/modules/home/routes-typed'
import { CompanyType, isUnusableServiceCompany } from '@/app/constants/companyType'

type SwitchCompany = { id: string; type?: CompanyType; hasDatabase?: boolean }

// Adresy modułów kierowców i pojazdów niosą identyfikatory encji
// (`/driver/:driverId`, `/vehicle/:vehicleId`), które nie istnieją w nowej
// firmie — dla nich wracamy na listę modułu zamiast otwierać nieistniejący
// rekord. Poza tym zachowujemy bieżący ekran.
const ENTITY_ID_IN_PATH = /\/(driver|vehicle)\/\d+/

/**
 * Adres, na który przechodzimy po wybraniu firmy `companyId`. Używają tego oba
 * przełączniki firm: ten w sidebarze i `CompanyNameBadge` na ekranach modułów.
 */
export const buildCompanySwitchPath = (
  pathname: string,
  companyId: string,
  companies?: SwitchCompany[],
): string => {
  const currentId = pathname.match(/\/company\/([^/]+)/)?.[1]
  // Oba przełączniki wołają handler także dla już wybranej firmy (na liście
  // jest ona pierwsza, pod kursorem), więc bez tego ponowne kliknięcie własnej
  // firmy wyrzucałoby z karty kierowcy/pojazdu na listę.
  if (currentId === companyId) {
    return pathname
  }

  // Firma usługowa bez bazy ma tylko swój panel, a jej ekrany (serviceAccount,
  // my-subscription) znaczą co innego w zwykłej firmie.
  const find = (id?: string) =>
    companies?.find((c) => String(c.id).toLowerCase() === id?.toLowerCase())
  if (isUnusableServiceCompany(find(companyId))) {
    return `/et/company/${companyId}/serviceAccount`
  }
  if (isUnusableServiceCompany(find(currentId))) {
    return HOME_ROUTES.dashboard.buildPath({ companyId })
  }

  const swapped = pathname.replace(
    /\/company\/([^/]+)/,
    `/company/${companyId}`,
  )

  if (!ENTITY_ID_IN_PATH.test(swapped)) {
    return swapped
  }

  if (swapped.includes('/driverModule/')) {
    return DRIVER_ROUTES.groupContracts.buildPath({ companyId })
  }

  if (swapped.includes('/vehicleModule/')) {
    return VEHICLE_ROUTES.list.buildPath({ companyId })
  }

  return swapped
}
